import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { PermissionRole } from '../../shared/models/Com/permission-role';

@Injectable({
  providedIn: 'root'
})
export class PermissionRoleService {

  constructor(private http:HttpRequestService) { }
  getAll(){
   return this.http.GetRequest('role/')
  }
  GetMenuPermssions(){
    return this.http.GetRequest('Permissions/menu')
  }
  GetPermssionsforMenu(menuId){
    return this.http.GetRequest('Permissions/menupermis/'+ menuId)
  }
  GetPermssionsforRole(role){
    return this.http.GetRequest('rolepermissions/RolePermiions/'+ role)
  }
  GetRolePermiions(roleId){
    return this.http.GetRequest('rolepermissions/RolePermiions/'+roleId)
  }
  AddPermissionRole(data:PermissionRole){
    return this.http.postRequest('rolepermissions/addPermissionRole/',data)
  }
  DeletePermissionRole(role:PermissionRole){
    return this.http.postRequest('rolepermissions/delete',role)
  }
}
